import { EMPTY_LIST } from '../../../constants/common'

export const REQUEST_EDIT_LABEL_FORM_LABEL_FIELD = 'label'

export const REQUEST_EDIT_LABEL_FORM_INITIAL_VALUES = {
  [REQUEST_EDIT_LABEL_FORM_LABEL_FIELD]: EMPTY_LIST,
}

export const QA_NAME_REQUEST_EDIT_LABEL_FORM_MODAL = 'editLabel'
